import { Component } from '@angular/core';

@Component({
    selector: 'app-signing-room-documents-loading',
    templateUrl: './documents-loading.component.html',
    styleUrls: ['./documents-loading.component.scss'],
    standalone: false
})
export class DocumentsLoadingComponent {
 
}
